/* eslint-disable import/prefer-default-export */
import { takeLatest, put, call, all } from 'redux-saga/effects' // eslint-disable-line
import getAllUniteRegionalesActions, {
    getAllUniteRegionalesTypes,
} from '../../../redux/uniteRegionale/getAllUniteRegionales'
import getDisabledUniteRegionalesActions, {
    getDisabledUniteRegionalesTypes,
} from '../../../redux/uniteRegionale/getDisabledUniteRegionales'
import { Get } from '../../../serveur/axios'

function* getAllUniteRegionalesSagas({ response }) {
    const { enable } = response || {}
    try {
        const res = yield Get(`uniteRegionale/?enable=${enable || 'false'}`)

        if (res.status === 200) {
            if (enable === 'true')
                yield all([
                    yield put(
                        getDisabledUniteRegionalesActions.getDisabledUniteRegionalesSuccess(
                            res.data.data
                        )
                    ),
                ])
            else
                yield all([
                    yield put(
                        getAllUniteRegionalesActions.getAllUniteRegionalesSuccess(
                            res.data.data
                        )
                    ),
                ])
        } else if (enable === 'true')
            yield put(
                getDisabledUniteRegionalesActions.getDisabledUniteRegionalesFailure(
                    res.data.data
                )
            )
        else if (enable === 'true')
            yield put(
                getDisabledUniteRegionalesActions.getDisabledUniteRegionalesFailure(
                    res.data.data
                )
            )
        else
            yield put(
                getAllUniteRegionalesActions.getAllUniteRegionalesFailure(
                    res.data.data
                )
            )
    } catch (error) {
        yield put(
            getAllUniteRegionalesActions.getAllUniteRegionalesFailure(error)
        )
    }
}

export function* getAllUniteRegionalesSaga() {
    yield takeLatest(
        getAllUniteRegionalesTypes.GET_ALL_UNITE_REGIONALES_REQUEST,
        getAllUniteRegionalesSagas
    )
    yield takeLatest(
        getDisabledUniteRegionalesTypes.GET_DISABLED_UNITE_REGIONALES_REQUEST,
        getAllUniteRegionalesSagas
    )
}
